import { defineNuxtRouteMiddleware } from '#app';
// import { useCategories } from '~/modules/categories/uses/useCategories';

export default defineNuxtRouteMiddleware(async (to, from) => {
  // const { updateCategories } = useCategories();

  // await callOnce(async () => {
  //   await updateCategories();
  // });
});
